import { Button } from 'reactstrap';

function TableRowsCreditNote({
    rowsData,
    taxes,
    cnType,
    onChange,
    onAddRow,
    onRemoveRow,
    readOnly = false,
}) {
    const handleChange = (index, event) => {
        const { name, value } = event.target;
        onChange(index, name, value);
    };

    return (
        <>
            <tbody>
                {rowsData.map((row, index) => (
                    <tr key={`cn-line-${index}`}>
                        <td>
                            {!readOnly && cnType === 'others' ? (
                                <Button
                                    type="button"
                                    className="btn btn-delete btn-sm"
                                    onClick={() => onRemoveRow(index)}
                                >
                                    X
                                </Button>
                            ) : (
                                '-'
                            )}
                        </td>
                        <td>{index + 1}</td>
                        <td>
                            {readOnly || cnType === 'sales_return' ? (
                                row.description
                            ) : (
                                <input
                                    className="form-control"
                                    name="description"
                                    value={row.description || ''}
                                    onChange={(event) => handleChange(index, event)}
                                />
                            )}
                        </td>
                        <td>{row.unit || ''}</td>
                        <td>
                            {readOnly ? (
                                row.qty
                            ) : (
                                <input
                                    type="number"
                                    className="form-control"
                                    name="qty"
                                    value={row.qty ?? ''}
                                    onChange={(event) => handleChange(index, event)}
                                    disabled={cnType === 'discount' || cnType === 'rate_difference'}
                                />
                            )}
                        </td>
                        <td>
                            {readOnly ? (
                                row.basic_rate
                            ) : (
                                <input
                                    type="number"
                                    className="form-control"
                                    name="basic_rate"
                                    value={row.basic_rate ?? ''}
                                    onChange={(event) => handleChange(index, event)}
                                    disabled={cnType === 'sales_return' || cnType === 'discount'}
                                />
                            )}
                        </td>
                        <td>
                            {readOnly ? (
                                row.taxable_amt
                            ) : (
                                <input
                                    type="number"
                                    className="form-control"
                                    name="taxable_amt"
                                    value={row.taxable_amt ?? ''}
                                    onChange={(event) => handleChange(index, event)}
                                />
                            )}
                        </td>
                        <td>
                            {readOnly ? (
                                row.tax_name || row.tax_id
                            ) : (
                                <select
                                    className="form-control"
                                    name="tax_id"
                                    value={row.tax_id || ''}
                                    onChange={(event) => handleChange(index, event)}
                                >
                                    <option value="">Select Tax</option>
                                    {taxes.map((tax) => (
                                        <option key={tax.value} value={tax.value}>
                                            {tax.label}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </td>
                        <td>{row.gst_amt ?? 0}</td>
                        <td>{row.gross_amt ?? 0}</td>
                    </tr>
                ))}
            </tbody>
            {!readOnly && cnType === 'others' ? (
                <tfoot>
                    <tr>
                        <td colSpan="10" className="text-left">
                            <Button type="button" className="btn btn-twitter btn-sm" onClick={onAddRow}>
                                Add Line
                            </Button>
                        </td>
                    </tr>
                </tfoot>
            ) : null}
        </>
    );
}

export default TableRowsCreditNote;
